import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/taggedTemplateLiteralLoose";
var _excluded = ["version", "title", "description", "source", "logo", "components", "data", "markdownProps", "exampleProps", "className", "children", "disableCorners", "disableDarkMode", "disableHeader", "disableBackToUp"];
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;
import { forwardRef } from 'react';
import '@wcj/dark-mode';
import { styled } from 'styled-components';
import BackToUp from '@uiw/react-back-to-top';
import { Github } from "./Github.js";
import { Corners } from "./Corners.js";
import { Example } from "./Example.js";
import { NavMenu, NavMenuView } from "./NavMenu.js";
import { useStores } from "./store.js";
import Markdown from "./Markdown.js";
import { Logo } from "./Logo.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var ExampleWrapper = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n  max-width: 56rem;\n  margin: 0 auto;\n  padding: 2.3rem 3rem;\n  display: flex;\n  justify-content: center;\n"])));
var Wrappper = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteralLoose(["\n  padding-bottom: 12rem;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Noto Sans', Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji';\n"])));
var Header = styled.header(_templateObject3 || (_templateObject3 = _taggedTemplateLiteralLoose(["\n  padding: 9rem 0 2rem 0;\n  text-align: center;\n  h1 {\n    font-weight: 900;\n    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Noto Sans', Helvetica, Arial, sans-serif,\n      'Apple Color Emoji', 'Segoe UI Emoji';\n  }\n"])));
export var SupVersion = styled.sup(_templateObject4 || (_templateObject4 = _taggedTemplateLiteralLoose(["\n  font-weight: 200;\n  font-size: 0.78rem;\n  margin-left: 0.5em;\n  margin-top: -0.3em;\n  position: absolute;\n  white-space: nowrap;\n"])));
var Description = styled.p(_templateObject5 || (_templateObject5 = _taggedTemplateLiteralLoose(["\n  max-width: 460px;\n  margin: 0 auto;\n  color: var(--color-fg-subtle, #6e7781);\n"])));
var InternalMarkdownPreviewExample = /*#__PURE__*/forwardRef((props, ref) => {
  var {
      version,
      title,
      description,
      source,
      logo = Logo,
      components,
      data,
      markdownProps,
      exampleProps,
      className = '',
      children,
      disableCorners = false,
      disableDarkMode = false,
      disableHeader = false,
      disableBackToUp = false
    } = props,
    reset = _objectWithoutPropertiesLoose(props, _excluded);
  var store = useStores();
  return /*#__PURE__*/_jsxs(Wrappper, _extends({
    className: "wmde-markdown-var " + className
  }, reset, {
    children: [/*#__PURE__*/_jsx(NavMenuView, {
      version: version,
      logo: logo,
      disableDarkMode: disableDarkMode,
      disableCorners: disableCorners
    }), !disableHeader && /*#__PURE__*/_jsxs(Header, {
      children: [logo, title && /*#__PURE__*/_jsxs("h1", {
        children: [title, version && /*#__PURE__*/_jsx(SupVersion, {
          children: version
        })]
      }), description && /*#__PURE__*/_jsx(Description, {
        children: description
      })]
    }), store.example && /*#__PURE__*/_jsx(ExampleWrapper, _extends({}, exampleProps, {
      children: store.example
    })), /*#__PURE__*/_jsx(Markdown, _extends({}, markdownProps, {
      source: source,
      data: {
        data,
        components,
        source
      }
    })), children, !disableBackToUp && /*#__PURE__*/_jsx(BackToUp, {
      children: "Top"
    })]
  }));
});
var MarkdownPreviewExample = InternalMarkdownPreviewExample;
MarkdownPreviewExample.Github = Github;
MarkdownPreviewExample.Corners = Corners;
MarkdownPreviewExample.Example = Example;
MarkdownPreviewExample.NavMenu = NavMenu;
export default MarkdownPreviewExample;